//Types
export const Types = {
  GET_DOCUMENTS: "GET_DOCUMENTS",
  GET_DOCUMENT: "GET_DOCUMENT",
  CREATE_DOCUMENTS: "CREATE_DOCUMENTS",
  UPDATE_DOCUMENTS: "UPDATE_DOCUMENTS",
  DELETE_DOCUMENTS: "DELETE_DOCUMENTS",
  UPLOAD_DOCUMENT_FILE: "UPLOAD_DOCUMENT_FILE",
  DELETE_DOCUMENT_FILE: "DELETE_DOCUMENT_FILE",
  SHOW_DOCUMENT: "SHOW_DOCUMENT",
  SHOW_ALL_DOCUMENTS: "SHOW_ALL_DOCUMENTS",
  SET_LOADING: "SET_LOADING_DOCUMENTS",
}

//Reducer
const initialState = {
  documents: null,
  document: null,
  documentFile: null,
  showDocument: null,
  showAllDocuments: null,

  loading: false,
}

const Documents = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_DOCUMENTS:
      return {
        ...state,
        documents: action.payload,
        loading: false,
      }
    case Types.GET_DOCUMENT:
      return {
        ...state,
        document: action.payload,
        loading: false,
      }
    case Types.CREATE_DOCUMENTS:
      return {
        ...state,
        document: action.payload,
        loading: false,
      }
    case Types.UPDATE_DOCUMENTS:
      return {
        ...state,
        document: action.payload,
        loading: false,
      }
    case Types.DELETE_DOCUMENTS:
      return {
        ...state,
        loading: false,
      }
    case Types.UPLOAD_DOCUMENT_FILE:
      return {
        ...state,
        documentFile: action.payload,
      }
    case Types.DELETE_DOCUMENT_FILE:
      return {
        ...state,
        documentFile: null,
      }
    case Types.SHOW_DOCUMENT:
        return {
          ...state,
          showDocument: action.payload,
          loading: false,
        }
    case Types.SHOW_ALL_DOCUMENTS:
      return {
        ...state,
        showAllDocuments: action.payload,
        loading: false,
      }
    case Types.SET_LOADING:
      return {
        ...state,
        loading: true,
      }

    default:
      return state;
  }
}

export default Documents;
